<mat-radio-group class="options" (change)="onSelectedOptionChange($event.value)">
  @for (option of options(); track $index) {
    <mat-radio-button class="filter-option" [value]="option" [checked]="selectedValue() === option.value">
      <mp-filter-option [option]="option" [optionLabelTemplate]="optionLabelTemplate()" />
    </mat-radio-button>
  }
</mat-radio-group>
